import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { AGENT_CONFIG } from '../types/agentConfig.js';
export const vhAgentsDescriptor = {
    name: AGENT_CONFIG,
    label: 'VH Agent',
    domain: 'vectorhub',
    collectionPath: 'org/{orgId}/vh_agents',
    pathPatternKeys: { orgId: 'string' },
    version: 1,
    description: 'VectorHub agent identity and module access. Written by VH console + server.',
    repositoryConfig: {
        dataSource: DataSourceStrategy.Firestore,
        cache: CacheStrategy.InMemory,
    },
    fields: [
        {
            name: 'agentId',
            label: 'Agent ID',
            type: 'string',
            required: true,
            maxLength: 128,
            description: 'Stable VH id (uuid or slug). Decoupled from firebaseUid (D0005).',
        },
        {
            name: 'firebaseUid',
            label: 'Firebase UID',
            type: 'string',
            required: true,
            maxLength: 128,
            description: 'Firebase Auth account uid. Server maps token.uid → agent.',
        },
        {
            name: 'name',
            label: 'Name',
            type: 'string',
            required: true,
            maxLength: 120,
        },
        {
            name: 'description',
            label: 'Description',
            type: 'string',
            required: true,
            maxLength: 500,
        },
        {
            name: 'allowedModules',
            label: 'Allowed Modules',
            type: 'array',
            required: true,
            arrayItemType: 'string',
            description: 'Agent-runtime module ids (e.g. print, data). Each slug max 80 chars.',
        },
        {
            name: 'printers',
            label: 'Exposed Printers',
            type: 'array',
            required: false,
            description: 'Subset of OS printers exposed for remote dispatch. Each item: { name (max 256), label (max 120) }.',
        },
        {
            name: 'createdAt',
            label: 'Created At',
            type: 'string',
            required: true,
            maxLength: 32,
            description: 'ISO 8601 timestamp set by the server.',
        },
    ],
};
//# sourceMappingURL=vhAgents.descriptor.js.map